<template>
  <section id="scenario-section" class="section">
    <section-content-wrapper paddingSm>
      <div class="simulation-wrapper">
        <section-title id="simulation-heading" :text="title" />
        <ul id="simulation" class="simulation-list" role="tablist">
        <simulation-box v-for="(item, index) in simulationContent.simulation" :key="index" :simulation="item" />
      </ul>
      <div class="simulation-summary-wrapper">
        <div class="simulation-card">
          <simulation-card v-for="(item, index) in simulationContent.simulation" :key="index" :simulation="item" />
        </div>
        <div class="simulation-summary">
          <section-sub-title :text="'Dzienne scenariusze spłat dla finansowania w kwocie ' + setScenarioAmount()"/>
        </div>
      </div>
      </div>
    <article id="scenarios" class="article">
      <scenario-box v-for="(item, index) in content.scenario" :key="index" :scenario="item" />
    </article>
    <ul class="simulation-legend-list">
            <li class="simulation-legend-list-item">
              <span class="simulation-square primary"></span>
              Twoja dzienna sprzedaż w Autopay
            </li>
            <li class="simulation-legend-list-item">
              <span class="simulation-square secondary"></span>
              Spłata finansowania ({{ percent }}% dziennej sprzedaży)
            </li>
          </ul>
    <button-open-dialog addingClass="scenario-button"></button-open-dialog>

    <slot></slot>
    </section-content-wrapper>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { NumberFormatterClass } from '../../class/calculator.class'
import ScenarioBox from './ScenarioBox'
import SimulationCard from '../simulation/SimulationCard'
import SimulationBox from '../simulation/SimulationBox'
import SectionSubTitle from '../common/SectionSubTitle'
import SectionTitle from '../common/SectionTitle'
import SectionContentWrapper from '../common/SectionContentWrapper'
import ButtonOpenDialog from '../common/ButtonOpenDialog.vue'

export default {
  name: 'ScenarioSection',
  components: {
    SectionTitle,
    SectionSubTitle,
    ScenarioBox,
    SectionContentWrapper,
    SimulationCard,
    SimulationBox,
    ButtonOpenDialog
  },
  props: ['content', 'simulationContent'],
  computed: {
    ...mapState({
      amount: state => state.scenarios.amount,
      percent: state => state.scenarios.percent
    })
  },
  methods: {
    setScenarioAmount () {
      return NumberFormatterClass.formatAmount(this.amount)
    }
  },

  data () {
    return {
      title: this.simulationContent.title
    }
  }
}
</script>
